// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-area {
  text-align: left;
  font-weight: 500;
  font-size: 20px !important;
  line-height: 26px;
  letter-spacing: 0;
  color: #212121 !important;
  opacity: 1;
}

.title-description {
  text-align: left;
  font-size: 14px !important;
  line-height: 22px;
  letter-spacing: 0;
  color: #888888 !important;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/JobEligibilityComponent/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ","sourcesContent":[".title-area {\n  text-align: left;\n  font-weight: 500;\n  font-size: 20px !important;\n  line-height: 26px;\n  letter-spacing: 0;\n  color: #212121 !important;\n  opacity: 1;\n}\n\n.title-description {\n  text-align: left;\n  font-size: 14px !important;\n  line-height: 22px;\n  letter-spacing: 0;\n  color: #888888 !important;\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
